import api from "@/plugins/axios";
import router from "@/router/index";
import { useGlobalStore } from "@/stores";

const actions = () => ({
  async createCourse(payload) {
    const res = await api.post("/api/course/create", payload);
    await this.uploadCourseFiles(payload, res.data)

    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "The course has been successfully created",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/academy/overview");
  },

  async editCourse(payload) {
    await this.uploadCourseFiles(payload.data, payload.id)
    const updateCourse = await api.post(`/api/course/${payload.id}`, payload.data);

    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "All changes have been saved!",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    return updateCourse;
    // router.push("/dashboard");
  },

  async uploadCourseFiles(payload, id) {
    if (payload.fileList?.length > 0) {
      const formData = new FormData();
      payload.fileList.forEach(
        (file) => formData.append("uploadedFiles", file)
      )

      await api.post(`/api/files/${id}/upload/course`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    }
  },

  async fetchCourseFile(filename, type = 'course_file') {
    const res = await api.get(`/api/files/${filename}`, {
      params: { type },
      responseType: "blob",
    });
    return res;
  },

  async createStudentEvaluation(payload) {
    await api.post("/api/evaluation/student/add", payload);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "The evaluation has been submitted",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/academy/overview");
  },

  async createCourseEvaluation(payload) {
    await api.post("/api/evaluation/course/add", payload);
    const globalStore = useGlobalStore();
    globalStore.showSnackbar({
      show: true,
      text: "The evaluation has been submitted",
      timeout: 3000,
      type: "success",
      position: "top",
    });
    router.push("/academy/overview");
  },

  async getStudentEvaluation(payload) {
    return await api.get(`/api/evaluation/student/${payload.id}`);
  },

  async getCourseEvaluation(payload) {
    return await api.get(`/api/evaluation/course/${payload.id}`);
  },

  async getAcademyOverview(payload) {
    const res = await api.get("/api/course/overview", {
      params: payload,
    });
    this.overview = res.data.content;

    let registeredBen = 0
    let preRegisteredBen = 0;
    let completedBen = 0;

    for (let courseIndex = 0; courseIndex < res.data.content.length; courseIndex++) {
      registeredBen += res.data.content[courseIndex].registeredBeneficiaries;
      preRegisteredBen += res.data.content[courseIndex].preregisteredBeneficiaries;
      completedBen += res.data.content[courseIndex].completedBeneficiaries;
    }
    this.registeredBeneficiariesSum = registeredBen;
    this.preRegisteredBeneficiariesSum = preRegisteredBen;
    this.completedBeneficiariesSum = completedBen;

    this.pagination.totalItems = res.data.totalElements;
    this.pagination.cuurentPage = res.data.number + 1;
    this.pagination.pageCount = res.data.totalPages;
  },

  async getCourse(payload) {
    const res = await api.get(`/api/course/${payload.id}`);
    return res.data;
  },

  async getAcademyDashboard() {
    const res = await api.get("/api/embed/dashboard/5");

    return res.data;
  },

  async getAcademyEvaluationsDashboard() {
    const res = await api.get("/api/embed/dashboard/8");

    return res.data;
  },

  async getEvaluation(payload) {
    const res = await api.get(`/api/evaluation/${payload}`);
    return res.data;
  },

  async downloadExcel(payload) {
    try {
      const response = await api.get("/api/course/overview/export", {
        params: payload,
        responseType: "blob",
      });

      return response;
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  },

  resetAction() {
    this.filters.keyword = null;
    this.filters.advanced = {
      cycle: null,
      sections: [],
      thematicAreas: [],
      types: [],
      status: [],
      branch: null,
      projects: [],
      regDates: [],
      startDates: [],
      endDates: [],
    };
  },
});

export default actions;
